var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createSlice } from '@reduxjs/toolkit';
import { MAIN_FORM_STEPS, } from './mainForm.types';
import { asSliceActions, asSliceSelectors } from '../types';
import { applicantService, helpers, } from '../../apiServices/applicant.service';
import { projectService } from '../../apiServices/project.service';
import { projectPageModel } from '../../pages/MainFormPage/formPages/ProjectPage/formModel';
import { applicantOccupationPageModel } from '../../pages/MainFormPage/formPages/ApplicantOccupationPage/formModel';
import { advicePageFormModel } from '../../pages/MainFormPage/formPages/AdvicePage/formModel';
import { initialDataSlice } from '../initialData/initialData.slice';
import { miscSlice } from '../misc/misc.slice';
import { applicantPageModel } from '../../pages/MainFormPage/formPages/ApplicantPage/formModel';
import { additionalChargeService, } from '../../apiServices/additionalCharge.service';
var SLICE_NAME = 'mainForm';
var initialState = {
    caseId: null,
    firstApplicantInternalId: null,
    secondApplicantInternalId: null,
    firstHouseholdId: null,
    secondHouseholdId: null,
    initialHref: '',
    activeStep: MAIN_FORM_STEPS.APPLICANT_PAGE,
    isAbleToProceed: true,
    isSubmitInProgress: false,
    isLeadSubmitted: false,
    applicantData: applicantPageModel.initialValues,
    projectData: projectPageModel.initialValues,
    applicantOccupationData: applicantOccupationPageModel.initialValues,
    adviceData: advicePageFormModel.initialValues,
};
var rawSlice = createSlice({
    name: SLICE_NAME,
    initialState: initialState,
    reducers: {
        setActiveStep: function (state, action) {
            state.activeStep = action.payload;
        },
        setIsAbleToProceed: function (state, action) {
            state.isAbleToProceed = action.payload;
        },
        setIsSubmitInProgress: function (state) {
            state.isSubmitInProgress = true;
        },
        resetIsSubmitInProgress: function (state) {
            state.isSubmitInProgress = false;
        },
        setIsLeadSubmitted: function (state, action) {
            state.isLeadSubmitted = action.payload;
            if (state.isLeadSubmitted) {
                state.isAbleToProceed = false;
            }
        },
        setInitialHref: function (state, action) {
            state.initialHref = action.payload;
        },
        setApplicantData: function (state, action) {
            state.applicantData = action.payload;
            // @note: may cause problems when slice will be separated page-by-page
            state.applicantOccupationData.applicantsAmount =
                action.payload.applicantsCount;
            state.applicantOccupationData.isSameHousehold =
                action.payload.isSameHousehold;
        },
        setProjectData: function (state, action) {
            state.projectData = action.payload;
        },
        setApplicantOccupationData: function (state, action) {
            state.applicantOccupationData = action.payload;
        },
        setAdditionalChargeData: function (state, action) {
            state.additionalChargeData = action.payload;
        },
        setAdditionalChargeLoanCorrection: function (state, action) {
            state.projectData.loanAmount = action.payload;
        },
        setAdditionalChargeAvailableEquityCorrection: function (state, action) {
            state.projectData.availableEquity = action.payload;
        },
        setAdviceData: function (state, action) {
            state.adviceData = action.payload;
        },
        setMortgageCaseMeta: function (state, action) {
            return __assign(__assign({}, state), action.payload);
        },
        resetMortgageCaseMeta: function (state) {
            state.caseId = null;
            state.firstApplicantInternalId = null;
            state.secondApplicantInternalId = null;
        },
    },
});
var selectors = asSliceSelectors({
    getActiveStep: function (state) {
        return state[SLICE_NAME].activeStep;
    },
    getIsAbleToProceed: function (state) {
        return state[SLICE_NAME].isAbleToProceed;
    },
    getIsSubmitInProgress: function (state) {
        return state[SLICE_NAME].isSubmitInProgress;
    },
    getIsLeadSubmitted: function (state) {
        return state[SLICE_NAME].isLeadSubmitted;
    },
    getInitialHref: function (state) {
        return state[SLICE_NAME].initialHref;
    },
    getApplicantData: function (state) { return state[SLICE_NAME].applicantData; },
    getProjectData: function (state) { return state[SLICE_NAME].projectData; },
    getApplicantOccupationData: function (state) {
        return state[SLICE_NAME].applicantOccupationData;
    },
    getAdditionalChargeData: function (state) { return state[SLICE_NAME].additionalChargeData; },
    getAdviceData: function (state) { return state[SLICE_NAME].adviceData; },
    getPreferredChannel: function (state) { return state[SLICE_NAME].adviceData.preferredChannel; },
    getCaseId: function (state) { return state[SLICE_NAME].caseId; },
    getBaseCost: function (state) { return state[SLICE_NAME].projectData.baseCost; },
    getAdditionalCost: function (state) { return state[SLICE_NAME].projectData.additionalCost; },
    getAvailableEquity: function (state) { return state[SLICE_NAME].projectData.availableEquity; },
    getLoanAmount: function (state) { return state[SLICE_NAME].projectData.loanAmount; },
    getFirstApplicantInternalId: function (state) {
        return state[SLICE_NAME].firstApplicantInternalId;
    },
    getSecondApplicantInternalId: function (state) {
        return state[SLICE_NAME].secondApplicantInternalId;
    },
    getFirstHouseholdId: function (state) {
        return state[SLICE_NAME].firstHouseholdId;
    },
    getSecondHouseholdId: function (state) {
        return state[SLICE_NAME].secondHouseholdId;
    },
    getMortgageCaseMeta: function (state) {
        // @todo [reselect]
        return {
            caseId: selectors.getCaseId(state),
            firstApplicantInternalId: selectors.getFirstApplicantInternalId(state),
            secondApplicantInternalId: selectors.getSecondApplicantInternalId(state),
            firstHouseholdId: selectors.getFirstHouseholdId(state),
            secondHouseholdId: selectors.getSecondHouseholdId(state),
        };
    },
});
var actions = asSliceActions({
    handleDataSaving: function (subAction) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    dispatch(rawSlice.actions.setIsSubmitInProgress());
                    return [4 /*yield*/, subAction()];
                case 1:
                    response = _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    e_1 = _a.sent();
                    if (e_1.response.status === 422) {
                        dispatch(rawSlice.actions.setIsLeadSubmitted(true));
                    }
                    throw e_1;
                case 3:
                    dispatch(rawSlice.actions.resetIsSubmitInProgress());
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/, response];
            }
        });
    }); }; },
    saveApplicantData: function (applicantFields) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, subAction;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(rawSlice.actions.setApplicantData(applicantFields));
                    state = getState();
                    subAction = function () { return __awaiter(void 0, void 0, void 0, function () {
                        var sourceCaseMeta, res, data;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    sourceCaseMeta = initialDataSlice.selectors.getSourceCaseMeta(state);
                                    return [4 /*yield*/, applicantService.saveApplicants(applicantFields, sourceCaseMeta)];
                                case 1:
                                    res = _a.sent();
                                    data = res.data;
                                    if (data.domainBlackListed === true) {
                                        dispatch(rawSlice.actions.setIsAbleToProceed(false));
                                        throw new Error("[Redux:saveApplicantData]: domain is blacklisted, can't proceed");
                                    }
                                    dispatch(rawSlice.actions.setMortgageCaseMeta(helpers.getMortgageCaseMetaFromSaveApplicantResponse(data)));
                                    return [2 /*return*/, res];
                            }
                        });
                    }); };
                    return [4 /*yield*/, dispatch(actions.handleDataSaving(subAction))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }; },
    saveProjectData: function (projectFields) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, mortgageCaseMeta, subAction;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    mortgageCaseMeta = selectors.getMortgageCaseMeta(state);
                    dispatch(rawSlice.actions.setProjectData(projectFields));
                    subAction = function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, projectService.saveFields(projectFields, mortgageCaseMeta)];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); };
                    return [4 /*yield*/, dispatch(actions.handleDataSaving(subAction))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }; },
    saveApplicantOccupationData: function (applicantOccupationFields) {
        return function (dispatch, getState) { return __awaiter(void 0, void 0, Promise, function () {
            var state, applicantFields, mortgageCaseMeta, subAction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        state = getState();
                        applicantFields = selectors.getApplicantData(state);
                        mortgageCaseMeta = selectors.getMortgageCaseMeta(state);
                        dispatch(rawSlice.actions.setApplicantOccupationData(applicantOccupationFields));
                        subAction = function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, applicantService.updateApplicantOccupation(applicantFields, applicantOccupationFields, mortgageCaseMeta)];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); };
                        return [4 /*yield*/, dispatch(actions.handleDataSaving(subAction))];
                    case 1: return [2 /*return*/, (_a.sent())];
                }
            });
        }); };
    },
    checkForAdditionalCharge: function () {
        return function (dispatch, getState) { return __awaiter(void 0, void 0, Promise, function () {
            var state, mortgageCaseMeta, subAction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        state = getState();
                        mortgageCaseMeta = selectors.getMortgageCaseMeta(state);
                        subAction = function () { return __awaiter(void 0, void 0, void 0, function () {
                            var projectRecommendation, data, err_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, additionalChargeService.getInitialCalculations(mortgageCaseMeta)];
                                    case 1:
                                        data = (_a.sent()).data;
                                        projectRecommendation = data.projectRecommendation;
                                        return [3 /*break*/, 3];
                                    case 2:
                                        err_1 = _a.sent();
                                        // if will respond with 500, should be considered as false
                                        projectRecommendation = null;
                                        return [3 /*break*/, 3];
                                    case 3:
                                        if (projectRecommendation !== null) {
                                            dispatch(rawSlice.actions.setAdditionalChargeData(additionalChargeService.mapProjectRecommendationDTOtoAdditionalChargeData(projectRecommendation)));
                                        }
                                        return [2 /*return*/, projectRecommendation !== null];
                                }
                            });
                        }); };
                        return [4 /*yield*/, dispatch(actions.handleDataSaving(subAction))];
                    case 1: return [2 /*return*/, (_a.sent())];
                }
            });
        }); };
    },
    makeAdditionalChargeCalculations: function (federalState) {
        return function (dispatch, getState) { return __awaiter(void 0, void 0, Promise, function () {
            var state, subAction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        state = getState();
                        subAction = function () { return __awaiter(void 0, void 0, void 0, function () {
                            var res, projectRecommendation;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, additionalChargeService.makeCalculations(mainFormSlice.selectors.getBaseCost(state), mainFormSlice.selectors.getAdditionalCost(state) || 0, mainFormSlice.selectors.getAvailableEquity(state), mainFormSlice.selectors.getLoanAmount(state), federalState, mainFormSlice.selectors.getMortgageCaseMeta(state))];
                                    case 1:
                                        res = _a.sent();
                                        projectRecommendation = res.data.projectRecommendation;
                                        if (projectRecommendation !== null) {
                                            dispatch(rawSlice.actions.setAdditionalChargeData(additionalChargeService.mapProjectRecommendationDTOtoAdditionalChargeData(projectRecommendation)));
                                        }
                                        return [2 /*return*/, res];
                                }
                            });
                        }); };
                        return [4 /*yield*/, dispatch(actions.handleDataSaving(subAction))];
                    case 1: return [2 /*return*/, (_a.sent())];
                }
            });
        }); };
    },
    saveAdditionalChargeDecision: function (loanAmount, availableEquity) {
        return function (dispatch, getState) { return __awaiter(void 0, void 0, Promise, function () {
            var state, mortgageCaseMeta, subAction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        state = getState();
                        mortgageCaseMeta = selectors.getMortgageCaseMeta(state);
                        subAction = function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, additionalChargeService.saveDecision(mortgageCaseMeta, loanAmount, availableEquity)];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); };
                        loanAmount > 0 &&
                            dispatch(rawSlice.actions.setAdditionalChargeLoanCorrection(loanAmount));
                        availableEquity > 0 &&
                            dispatch(rawSlice.actions.setAdditionalChargeAvailableEquityCorrection(availableEquity));
                        return [4 /*yield*/, dispatch(actions.handleDataSaving(subAction))];
                    case 1: return [2 /*return*/, (_a.sent())];
                }
            });
        }); };
    },
    saveAdviceData: function (adviceFields) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, mortgageCaseMeta, subAction;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    mortgageCaseMeta = selectors.getMortgageCaseMeta(state);
                    dispatch(rawSlice.actions.setAdviceData(adviceFields));
                    subAction = function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, applicantService.updateApplicantContact(adviceFields, mortgageCaseMeta)];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); };
                    return [4 /*yield*/, dispatch(actions.handleDataSaving(subAction))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }; },
    restartSession: function () { return function (dispatch, getState) {
        var state = getState();
        var initialHref = selectors.getInitialHref(state);
        dispatch(miscSlice.actions.redirectAppToPage(initialHref));
    }; },
});
export var mainFormSlice = {
    name: SLICE_NAME,
    actions: __assign(__assign({}, rawSlice.actions), actions),
    selectors: selectors,
    getInitialState: function () {
        return initialState;
    },
};
export default rawSlice.reducer;
